import './wdyr.mjs'
import React from 'react'
import ReactDOM from 'react-dom'
//import {createRoot} from 'react-dom/client'
import 'core-js/actual'
import "@/style/tailwindStyles/global.css";
import './main.css'
import '@/style/main.css'
import App from './App.jsx'

const container = document.getElementById('root')

const app = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
)

//const root = createRoot(container)
//root.render(app)

ReactDOM.render(app, container)
